import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function ConfirmDialog({ title, message, onConfirm, onCancel, confirmText = '确认删除', cancelText = '取消', }) {
    return (_jsx("div", { style: overlayStyle, onClick: onCancel, children: _jsxs("div", { style: dialogStyle, onClick: (e) => e.stopPropagation(), children: [_jsx("h3", { style: { margin: '0 0 12px', fontSize: 16, fontWeight: 600, color: '#111827' }, children: title }), _jsx("p", { style: { margin: '0 0 20px', fontSize: 14, color: '#6b7280', lineHeight: 1.5 }, children: message }), _jsxs("div", { style: { display: 'flex', gap: 8, justifyContent: 'flex-end' }, children: [_jsx("button", { onClick: onCancel, style: {
                                padding: '8px 16px',
                                borderRadius: 8,
                                border: '1px solid #d1d5db',
                                backgroundColor: '#fff',
                                fontSize: 13,
                                color: '#4b5563',
                                cursor: 'pointer',
                            }, children: cancelText }), _jsx("button", { onClick: onConfirm, style: {
                                padding: '8px 16px',
                                borderRadius: 8,
                                border: 'none',
                                backgroundColor: '#dc2626',
                                color: '#fff',
                                fontSize: 13,
                                fontWeight: 500,
                                cursor: 'pointer',
                            }, children: confirmText })] })] }) }));
}
const overlayStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.5)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1000,
};
const dialogStyle = {
    width: '100%',
    maxWidth: 380,
    backgroundColor: '#fff',
    borderRadius: 16,
    padding: 24,
    boxShadow: '0 20px 60px rgba(0,0,0,0.2)',
};
//# sourceMappingURL=confirm-dialog.js.map